// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__qamY2","title":"Info_title__2TP5P","selects":"Info_selects__1EqVK","requiredAsterisk":"Info_requiredAsterisk__PqXbG"};